import React, { Fragment } from 'react';
import { translate } from '../Services/translation';

const QuickSearchResultItem = ({
  skipPaddingRight = false,
  title,
  items,
  max = 3,
  lg = 1,
  linkName = false,
}) => {
  return (
    <div
      className={`columns small-12 large-${lg === 1 ? 3 : 6} ${
        skipPaddingRight ? 'no-padding' : ''
      }`}
    >
      <div className="quick-search-result__title">
        {translate(`quicksearch.${title}`)} ({items.length})
      </div>
      {items.length === 0 ? (
        <div className="row columns small-12">
          {translate('quicksearch.nohits')}
        </div>
      ) : (
        <div className={`row small-up-1 large-up-${lg}`}>
          {items.slice(0, max).map((item, index) => (
            <div key={index} className={`columns quick-search-result__item`}>
              <a href={item.url}>
                <div
                  className={`quick-search-result__item--content content-type--${title} ${
                    linkName ? 'link' : ''
                  }`}
                >
                  {item.hasImage ? (
                    <figure className="quick-search-result__image-wrapper">
                      <img
                        className="quick-search-result__image"
                        src={item.imageSource}
                      />
                    </figure>
                  ) : (
                    <div className="quick-search-result__image-wrapper"></div>
                  )}
                  <div className="quick-search-result__item--names">
                    {linkName ? (
                      <button className="button link dark">{item.name}</button>
                    ) : (
                      <Fragment>
                        {/*<div className="quick-search-result__item--subName"></div>*/}
                        <div className="quick-search-result__item--name">
                          {item.name}
                        </div>
                      </Fragment>
                    )}
                  </div>
                </div>
              </a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default QuickSearchResultItem;
